export const GET_LATEST_RATE = 'GET_LATEST_RATE';
export const GET_LATEST_RATE_SUCCESS = 'GET_LATEST_RATE_SUCCESS';
export const GET_LATEST_RATE_ERROR = 'GET_LATEST_RATE_ERROR';

export const GET_HISTORICAL_RATES = 'GET_HISTORICAL_RATES';
export const GET_HISTORICAL_RATES_SUCCESS = 'GET_HISTORICAL_RATES_SUCCESS';
export const GET_HISTORICAL_RATES_ERROR = 'GET_HISTORICAL_RATES_ERROR';

export const getLatestRate = (base, target) => ({
  type: GET_LATEST_RATE,
  payload: { base, target },
});

export const getHistoricalRates = (base, target, startDate, endDate) => ({
  type: GET_HISTORICAL_RATES,
  payload: { base, target, startDate, endDate },
});
